angular.module("bribac.components.filterOrganization", [
    "ui.bootstrap",
    "bribac.translations",
    "bribac.entities.kinds",
    "bribac.services.api",
    "bribac.services.errorUtils",
    "bribac.components.whenLoaded",
    "bribac.components.scheduleDetails"
  ])

  .component("filterOrganization", {
    templateUrl: "filter-organization-component.html",
    controller: "FilterOrganizationComponentCtrl",
    bindings: {
      organization: '=',
      includeAllOrganizations: '<'
    }
  })

  .controller("FilterOrganizationComponentCtrl", function(
    api,
    KINDS,
    $translate,
    state
  ) {
    var $ctrl = this;
    $ctrl.status = $ctrl.includeAllOrganizations ? "all" : "active"

    $ctrl.$onInit = function() {
      if (state.lastSelectedShowInactiveOrganization !== undefined) {
        $ctrl.showInactiveOrganization = state.lastSelectedShowInactiveOrganization
        updateStatus()
      }
      getOrganizations($ctrl.status)
    }

    $ctrl.showOrganization = function(){
      state.lastSelectedShowInactiveOrganization = $ctrl.showInactiveOrganization
      updateStatus()
      getOrganizations($ctrl.status, {clearOrganization: true})
    }

    function updateStatus() {
      $ctrl.status = $ctrl.showInactiveOrganization ? "inactive" : "active"
    }

    function getOrganizations(status, params) {
      params = params || {}
      $ctrl.organizationsPromise = api.getView(KINDS.ORGANIZATION + "?status=" + status).then(function(request) {
        $ctrl.organizations = request.data.list
        var translatedAll = $translate.instant('organizationFilter.all', null, "", "", "")
        if ($ctrl.includeAllOrganizations) {
          $ctrl.organizations.unshift({id: -1, name: translatedAll})
        }
        /*
          As per angularjs documentation: The empty option is generated when a value referenced
          by ng-model doesn't exist in a set of options passed to ng-options.
          To fix this behavior we can set a default value to select option.
        */
        if (!$ctrl.organization || params.clearOrganization) {
          if (status == "inactive" && $ctrl.organizations.length > 1) {
            $ctrl.organization = $ctrl.organizations[1]
          } else if ($ctrl.organizations.length == 1) {
            $ctrl.organization = $ctrl.organizations[0]
          } else {
            $ctrl.organization = state.currentAgent.organization
          }
        }
      })
    }
  })
